<template lang="pug">
  .row-creator
    template(v-if="column && value.length !== 0 && !isMultiple && !isOtherNames" )
      .row-creator__container
        .column
          p.value(v-for="(r, i) in value", :key="i") {{ r }}
          a.toggle(v-if="fullList" @click="showMoreInModal(fullList)") Show all ({{getTotal}})
        lei-popover(v-if="tip && tooltip && challengeMode" :text="tip", placement="right")

    template(v-else-if='isMultiple')
      multiple-rows(:item="item" :value="value")

    template(v-else-if='showWithLabel')
      label-row(:item="item" :value="value")

    template(v-else-if="value && isOtherNames")
      div.value(v-for="(r, i) in value", :key="i") {{ r.name }}
        span.label {{ r.value }}

    template(v-else-if="value && isLeiIssuer")
      lei-issuer-block(:lei-issuer="value")

    template(v-else-if="value && isEntity")
      entity-block(:entity="value")

    template(v-else-if="value && isExpiration")
      expiration-block(:expiration="value")

    template(v-else-if="value && link")
      .inline
        a.value.link(:href="link", target="blank" data-test-id="test-links") {{value}}
        lei-popover(v-if="tip && tooltip" :text="tip", placement="right")

    template(v-else-if="to && value")
      router-link.value.link(:to="to") {{value}}

    template(v-else-if="isStatus && value")
      p.value.status
        lei-status(:status="value")

    template(v-else-if="isLeiLink && value")
      lei-code-link.value(:lei="value")

    template(v-else-if="!column && value && !isDeprecated")
      .row-creator__container
        p.value {{value}}
        lei-popover(v-if="tip && tooltip" :text="tip", placement="right")

    template(v-else-if="isDeprecated")
      deprecated-block(:item="item")

    template(v-else-if="isEmpty(value)")
      .row-creator__container
        p.value.n-a(:class="{disabled: isDisabled}") not available
        lei-popover(v-if="tip && tooltip && challengeMode" :text="tip", placement="right")

</template>
<script>
import { TOGGLE_FULL_DATA_MODAL, } from '@/store/modules/record/mutations-types'
import { mapMutations, } from 'vuex'
import ExpirationBlock from '@/components/record-details/table-components/ExpirationBlock'
import LeiIssuerBlock from './LeiIssuerBlock'
import MultipleRows from '@/components/record-details/table-components/MultipleRows'
import LabelRow from '@/components/record-details/table-components/LabelRow'
import DeprecatedBlock from '@/components/record-details/table-components/DeprecatedBlock'
import EntityBlock from './EntityBlock'
import LeiCodeLink from './LeiCodeLink'
import LeiStatus from '../../lei-components/LeiStatus'
import LeiPopover from '@/components/lei-components/LeiPopover'


export default {
  components: {
    LeiCodeLink,
    ExpirationBlock,
    EntityBlock,
    LeiIssuerBlock,
    LeiStatus,
    MultipleRows,
    LabelRow,
    DeprecatedBlock,
    LeiPopover,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    rowClass: {
      type: String,
      default: 'value',
    },
    value: {
      type: [ Object, Array, String, ],
      default: null,
    },
    fullList: {
      type: Object,
      default: null,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    challengeMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    column () {
      return Array.isArray(this.value)
    },
    changed () {
      return this.newValue
    },
    isLeiIssuer () {
      return this.item.isLeiIssuer
    },
    link () {
      return this.item.link
    },
    to () {
      return this.item.to
    },
    tip () {
      return this.item.tip
    },
    isLeiLink () {
      return this.item.leiLink
    },
    isStatus () {
      return this.item.isStatus
    },
    isExpiration () {
      return this.item.isExpiration
    },
    isDeprecated () {
      return this.item.isDeprecated
    },
    isDisabled () {
      return this.item.disabled && this.challengeMode
    },
    isEntity () {
      return this.item.isEntity
    },
    isMultiple () {
      return this.item.multiple
    },
    showWithLabel () {
      return this.item.withLabel
    },
    getTotal () {
      return this.fullList.meta.pagination.total
    },
    isOtherNames () {
      return this.item.isOtherNames
    },
  },
  methods: {
    isEmpty (value) {
      return !value || value === '' || (Array.isArray(value) && value.length === 0)
    },
    showMoreInModal (fullList) {
      this.toggleModal({
        show: true,
        fullList,
      })
    },
    ...mapMutations('record', {
      toggleModal: TOGGLE_FULL_DATA_MODAL,
    }),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"
  .toggle
    color $default-color
    font-weight 600
    text-decoration underline

  .row-creator
    width: 100%
    height: 100%

    .inline
      display flex

    &__container
      display flex
      justify-content space-between

    .column
      justify-content center
      align-items flex-start
      flex-direction column

    .value.old, .old .value
      color $default-color-middle

    .value
      color $default-color-bold-1
      font-weight 500

      &.link
        color $default-color-bold-1
        font-weight 500
        cursor pointer
        line-height 1.5rem
        border-bottom 1px solid $info-color
        transition all .2s ease

        &:hover
          color $primary-color
          border-bottom 1px solid $primary-color

      &.n-a
        color $default-color-middle

      &.disabled
        color $disabled-color

      &.status
        font-size 85%
        display flex
        align-items center

        .status-icon
          font-size 125%
          margin-right 8px

      .label
        margin-left 10px
        font-size 90%
        opacity 0.5
</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/RowCreator.vue